import { get, post } from '@/utils/request.js'
import { h5ProductApi } from '../base/urlConfig.js'


/**
 * @func 获取H5商品
 * @returns
 */
export function FetchH5ProductAllService() {
    var url = h5ProductApi.FetchProductAll
    return get(url)
}

/**
 * @func 获取H5分类产品
 * @returns
 */
export function FetchProductByCategoryService() {
    var url = h5ProductApi.FetchProductByCategory
    return get(url)
}


export function FetchProductBySKUService(sku) {
    var url = h5ProductApi.FetchProductBySKU + sku + "/"
    return get(url)
}
